module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data04-65addd4a371fc95b1ca8fc7b9463fc1c.png";